export default {
  donationMerchants: 'Donation settings',
  transferLocations: 'Transfer settings',
  donationActivities: 'Donation campaigns',
  paymentConfig: 'Payment settings',
  associationPlans: 'Association plans',
  associationActivationRecords: 'Activations',
  memberDataOverview: 'Membership overview',
  operationLogs: 'Operation logs',
  groupTodo: 'To-dos',
  groupProject: 'Projects',
  groupAssets: 'Data assets',
  groupAccount: 'Account',
  groupPlatform: 'Platform',
  groupSysAdmin: 'System',
  groupUserSystem: 'System',
  groupFinance: 'Finance',
  groupAdmin: 'Administration',
  groupSuperAdmin: 'Super Admin',
  bizStats: 'Business analytics',
  todoTasks: 'Task inbox',
  photoLive: 'Photo Live',
  cloudSpace: 'Cloud storage',
  associationManage: 'Association management',
  associationDashboard: 'Dashboard',
  associationHomeDecoration: 'Mini-program design',
  associationHomePage: 'Home page',
  associationPersonalCenter: 'Personal center',
  associationBottomNavigation: 'Bottom navigation',
  associationLinkManagement: 'Link management',
  associationQuestionnaires: 'Questionnaires',
  associationMiniProgramConfig: 'Mini-program settings',
  associationProfile: 'Association profile',
  associationOverview: 'Overview',
  associationJoinSettings: 'Join settings',
  associationJoinApplication: 'Join applications',
  associationMemberLevels: 'Member levels',
  associationJoinTypes: 'Join types',
  associationMiniProgram: 'Association mini-program',
  associationMembers: 'Members',
  associationFeeSettings: 'Fee settings',
  associationMemberList: 'Member list',
  associationMemberShowcase: 'Member showcase',
  associationRenewalManage: 'Renewal management',
  associationPaymentMethods: 'Payment methods',
  associationActivities: 'Activities',
  associationActivityList: 'Activity list',
  associationActivityAlbum: 'Photo album',
  associationActivityRegistration: 'Registrations',
  associationActivityRefund: 'Refunds',
  associationDemand: 'Supply & Demand',
  associationNews: 'News',
  associationArticleList: 'Articles',
  associationArticleCategories: 'Categories',
  associationFeeRecords: 'Fee records',
  conference: 'Events',
  eventManage: 'Events',
  lotteryManage: 'Big-screen lottery',
  votingManage: 'Voting management',
  registrationManage: 'Questionnaires',
  venueManage: 'Seat management',
  seatLayouts: 'Layouts',
  seatUsageRecords: 'Usage records',
  hotelManage: 'Hotels',
  receptionManage: 'Reception setup',
  donationManage: 'Donations',
  cardManage: 'Name cards',
  memberManage: 'Members',
  helpManage: 'Help management',
  memberPlan: 'Membership plans',
  accountHub: 'Account',
  myMembership: 'My membership',
  memberPlanDetail: 'Plan details',
  memberPlanOrders: 'Purchase history',
  memberPlanActivations: 'Activations',
  companyPlanManage: 'Plan tiers',
  referralConfig: 'Referral settings',
  accountManage: 'Accounts',
  rechargePlan: 'Recharge plans',
  myRechargePacks: 'My packs',
  rechargeRecords: 'Recharge history',
  rechargeOverview: 'Recharge overview',
  rechargeResourceManage: 'Recharge pack catalog',
  myInvitations: 'My invitations',
  invitationConfig: 'Invitation settings',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies',
  userManage: 'Users',
  userVerificationConfig: 'Verification Settings',
  userVerificationReviews: 'Verification Reviews',
  userList: 'User list',
  resourceGrantManage: 'Resource grants',
  attendeeManage: 'Attendees',
  staffManage: 'Staff',
  orderRecords: 'Orders',
  assetManage: 'Finance & assets',
  messageNotifications: 'Notifications',
  personalCenter: 'Personal center'
}
